var _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Chat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_Chat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-2",
    "data-name": "Chat"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M3.222,18.778A11,11,0,1,1,18.778,3.222a11.007,11.007,0,0,1,2.1,12.622l.757,3.406a2,2,0,0,1-1.518,2.386,2,2,0,0,1-.868,0l-3.406-.757a11.007,11.007,0,0,1-12.622-2.1ZM2,11a9,9,0,0,0,13.237,7.943,1.007,1.007,0,0,1,.472-.118,1.024,1.024,0,0,1,.216.023l3.758.835-.835-3.758a1,1,0,0,1,.094-.688A9,9,0,1,0,2,11Zm10,0a2,2,0,1,1,2,2A2,2,0,0,1,12,11ZM6,11a2,2,0,1,1,2,2A2,2,0,0,1,6,11Z",
    fill: "#b5b5be"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Notification",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(16)",
    fill: "#e0a422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.918c30ee84d8366f05e255f43e979874.svg";
export { ForwardRef as ReactComponent };